var _excluded = ["as", "className"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { useAsProp } from "@xo-union/react-polymorphic";
import styles from "./styles.css";

/**
 * Wrap content that should only be visible to screen readers.
 *
 * ref is forwarded to underlying element
 *
 *
 * ### When to use `ScreenReaderOnly` instead of `aria-label`
 *
 * Use this component when the screen-reader content is a superset of the visual content or in
 * cases where the existing HTML is complex (hierarchically) but is mostly correct when read out
 * loud by a screen-reader -- In this case `ScreenReaderOnly` should only enhance the information
 * that is already present in the DOM. In this scenario `ScreenReaderOnly` will also help you avoid
 * duplication of HTML text (that may be rendered in separate HTML nodes) on `aria-label`
 * properties.
 *
 */
var ScreenReaderOnly = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var as = _ref.as,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var ComponentToRender = useAsProp(as);
  return /*#__PURE__*/React.createElement(ComponentToRender, _extends({
    ref: ref,
    className: cx(styles['sr-only'], className)
  }, props));
});
process.env.NODE_ENV !== "production" ? ScreenReaderOnly.propTypes = {
  /**
   * Underlying element type to render
   */
  as: PropTypes.elementType,
  /**
   * Additional class to append
   */
  className: PropTypes.string
} : void 0;
ScreenReaderOnly.defaultProps = {
  as: 'span'
};
export default ScreenReaderOnly;